import { useCallback } from "react";
import { useMutation, useRelayEnvironment } from "react-relay";
import { graphql } from "relay-runtime";

import { useEmployeeId } from "../EmployeeId";
import { TodoStatus } from "./__generated__/useWidgetTodoSubscriptionCreatedSubscription.graphql";
import { useTodoSetStatusMediumMutation } from "./__generated__/useTodoSetStatusMediumMutation.graphql";
import { setOrdinalMap } from "arkh";

export const useTodoSetStatus = (id: string) => {
  const currentEmployeeId = useEmployeeId();
  const [updateStatus] = useMutation<useTodoSetStatusMediumMutation>(graphql`
    mutation useTodoSetStatusMediumMutation(
      $todoId: ID!
      $newStatus: TodoStatus!
      $employeeId: ID
    ) {
      todo(todoId: $todoId, employeeId: $employeeId) {
        updateTodoItemStatus(input: { status: $newStatus }) {
          todo {
            id
            status
            ordinal

            lastChangedStatusByActor {
              ...Avatar_actor
            }
          }
        }
      }
    }
  `);

  const cb = useCallback(
    (newStatus: TodoStatus) => {
      updateStatus({
        optimisticUpdater: (store) => {
          store.get(id)?.setValue(newStatus, "status");
        },
        variables: {
          todoId: id,
          newStatus,
          employeeId: currentEmployeeId,
        },
      });
    },
    [id, updateStatus, currentEmployeeId]
  );

  return useCallback(
    (newStatus: TodoStatus, currentOrdinal: string) => {
      setOrdinalMap(id, currentOrdinal);
      cb(newStatus);
    },
    [id, cb]
  );
};
